import {Component} from '@angular/core';

@Component({
  selector: 'app-default-full',
  templateUrl: './default-full-overlay.component.html',
  styleUrls: ['./default-full-overlay.component.scss']
})
export class DefaultFullOverlayComponent {
}
